import { render, staticRenderFns } from "./SystemDetails.vue?vue&type=template&id=e0b2ea86"
import script from "./SystemDetails.vue?vue&type=script&lang=js"
export * from "./SystemDetails.vue?vue&type=script&lang=js"
import style0 from "./SystemDetails.vue?vue&type=style&index=0&id=e0b2ea86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports